import React, { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "universal-cookie";
import Swal from "sweetalert2";
import img from "../IMAGEN/spinner.gif";
import {
  estadosParametrosTipoUsuario,
  obtenerTodosEstados,
} from "../Services/Rest";

const CreaGestionEspecial = ({ id }) => {
  const cookie = new Cookies();
  const tipoUsuario = cookie.get("tipo_Usuario");
  const correoGestor = cookie.get("correoGestor");
  const correoCreador = cookie.get("correo");
  const usuarioId = cookie.get("id");

  const urlEstados =
    tipoUsuario == 1
      ? obtenerTodosEstados
      : `${estadosParametrosTipoUsuario}${tipoUsuario}`;

  const [isLoading, setLoading] = useState(false);
  const [estados, setEstados] = useState([]);
  const [estadoSeleccionado, setEstadoSeleccionado] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [archivo, setArchivo] = useState(null);

  const fechaCreacion = new Date().toISOString().split("T")[0];

  useEffect(() => {
    const cargarEstados = async () => {
      try {
        const res = await fetch(urlEstados);
        const data = await res.json();
        setEstados(data);
      } catch (error) {
        console.error("Error al cargar estados:", error);
      }
    };
    cargarEstados();
  }, []);

  const subirArchivo = (e) => {
    setArchivo(e.target.files[0]);
  };

  const subirArchivoYObtenerURL = async (archivo) => {
    const formData = new FormData();
    formData.append("file", archivo);

    const response = await axios.post(
      "https://educacionapi.azurewebsites.net/api/AdjuntaArchivos",
      formData
    );

    return response.data.fileURL;
  };

  const insertarGestion = async () => {
    if (!estadoSeleccionado || !descripcion.trim()) {
      Swal.fire(
        "Campos requeridos",
        "Debe completar los campos obligatorios.",
        "warning"
      );
      return;
    }

    setLoading(true);

    try {
      const payload = {
        Descripciongestion: descripcion,
        FechaCreacion: fechaCreacion,
        TipoGestion: "TestGestion",
        SolicitudId: id,
        UsuarioId: usuarioId,
        Estado: estadoSeleccionado,
        Origen: "Especial",
        DetalleSolicitud: "0",
        correoGestor,
        correoCreador,
      };

      if (archivo) {
        const fileURL = await subirArchivoYObtenerURL(archivo);
        payload.Adjunto = fileURL;

        await axios.post(
          "https://educacionapi.azurewebsites.net/api/CreaGestionEspecialJson",
          payload,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
      } else {
        await axios.post(
          "https://educacionapi.azurewebsites.net/api/CreaGestionEspecialSinJson",
          payload,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
      }

      Swal.fire({
        title: "Gestión creada",
        text: "Se guardó correctamente",
        icon: "success",
      }).then(() => window.location.reload());
    } catch (error) {
      console.error("Error al crear gestión:", error);
      Swal.fire("Error", "No se pudo crear la gestión", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <div className="card shadow">
        <div className="card-header">
          <h5 className="text-primary">Nueva Gestión Especial</h5>
        </div>
        <div className="card-body">
          <form onSubmit={(e) => e.preventDefault()}>
            <div className="form-group">
              <label>Estado *</label>
              <select
                className="form-control"
                value={estadoSeleccionado}
                onChange={(e) => setEstadoSeleccionado(e.target.value)}
                required
              >
                <option value="">Seleccione un estado</option>
                {estados.map((estado) => (
                  <option key={estado.id} value={estado.id}>
                    {estado.estado}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>Descripción *</label>
              <textarea
                className="form-control"
                rows="4"
                maxLength="600"
                value={descripcion}
                onChange={(e) => setDescripcion(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label>Adjuntar Archivo (opcional)</label>
              <input
                type="file"
                className="form-control"
                onChange={subirArchivo}
              />
            </div>

            <div className="text-center mt-4">
              {isLoading ? (
                <button className="btn btn-secondary" disabled>
                  <img
                    src={img}
                    alt="Cargando..."
                    style={{ width: 70, height: 70 }}
                  />
                  Cargando...
                </button>
              ) : (
                <button className="btn btn-primary" onClick={insertarGestion}>
                  Guardar
                </button>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreaGestionEspecial;
